import { typeSafeObjectFromEntries } from '../../util/index.js';
import { ProviderName } from '../providers/index.js';
import metadata from '../providers/metadata.js';
export const getSubscriptionStatus = (allSubs) => {
    const result = {};
    // Initialize subsByProvider with all ProviderName keys
    const subsByProvider = typeSafeObjectFromEntries(Object.values(ProviderName).map((provider) => [provider, []]));
    for (const sub of allSubs) {
        if (!subsByProvider[sub.provider]) {
            continue;
        }
        subsByProvider[sub.provider].push(sub);
    }
    for (const provider in subsByProvider) {
        const subs = subsByProvider[provider];
        // Find active subscription
        const activeSub = subs.find((s) => s.unsubscribedAt === null);
        if (activeSub) {
            result[provider] = {
                sub: activeSub,
                metadata: metadata[provider],
            };
        }
        else {
            // Find most recently unsubscribed
            const mostRecent = subs.reduce((latest, curr) => {
                if (!latest) {
                    return curr;
                }
                if (!curr.unsubscribedAt) {
                    return latest;
                }
                if (!latest.unsubscribedAt) {
                    return curr;
                }
                return curr.unsubscribedAt > latest.unsubscribedAt ? curr : latest;
            }, undefined);
            if (mostRecent) {
                result[provider] = {
                    sub: mostRecent,
                    metadata: metadata[provider],
                };
            }
        }
    }
    return result;
};
//# sourceMappingURL=providers.js.map